module.exports = __webpack_public_path__ + "img/send_no_tex.0a8a114c.svg";